var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.998,
    height: 50,
    viewBox: "0 0 49.998 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625",
    transform: "translate(455.332 -79.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4450",
    "data-name": "Path 4450",
    d: "M-430.313,129.657a24.966,24.966,0,0,1-25.019-24.948,24.962,24.962,0,0,1,24.973-25.051,24.991,24.991,0,0,1,25.024,24.955A24.961,24.961,0,0,1-430.313,129.657Zm-.03-41.276a16.331,16.331,0,0,0-16.265,16.3,16.331,16.331,0,0,0,16.252,16.254,16.351,16.351,0,0,0,16.3-16.275A16.328,16.328,0,0,0-430.342,88.381Z",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4451",
    "data-name": "Path 4451",
    d: "M-345.582,203.154a13.7,13.7,0,0,1-13.741-13.77,13.7,13.7,0,0,1,13.738-13.712,13.711,13.711,0,0,1,13.743,13.772A13.7,13.7,0,0,1-345.582,203.154Zm1.266-15.008v-1.4c0-1.954.009-3.907,0-5.861-.005-.979-.567-1.532-1.426-1.447-.678.067-1.1.617-1.1,1.477-.007,2.188,0,4.376,0,6.565,0,.183-.021.366-.038.633-1-.741-1.908-1.435-2.836-2.108a1.221,1.221,0,0,0-1.854.171,1.252,1.252,0,0,0,.37,1.834q2.314,1.746,4.637,3.481a1.371,1.371,0,0,0,2.006-.02q2.3-1.716,4.591-3.445a1.258,1.258,0,0,0,.4-1.83,1.232,1.232,0,0,0-1.9-.17C-342.379,186.69-343.281,187.372-344.316,188.145Zm-1.258,8.774q3.017,0,6.034,0a1.308,1.308,0,0,0,1.454-1.008q.583-1.712,1.144-3.43a1.294,1.294,0,0,0-.706-1.745,1.285,1.285,0,0,0-1.673.95c-.262.753-.521,1.509-.747,2.273a.574.574,0,0,1-.658.479q-4.862-.023-9.724,0a.571.571,0,0,1-.646-.494c-.22-.746-.475-1.482-.726-2.219a1.3,1.3,0,0,0-1.649-1,1.291,1.291,0,0,0-.743,1.771c.367,1.128.748,2.252,1.128,3.375a1.316,1.316,0,0,0,1.48,1.049Q-348.591,196.923-345.574,196.92Z",
    transform: "translate(-84.751 -84.754)",
    fill: "#d10a11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.233f3cd402eeed15a64e396c6b639594.svg";
export { ForwardRef as ReactComponent };